import calendar from './lunar';
import festival from './festival';

export const getFestivalForDate = (year, month, day) => {
  const todayLunar = calendar.solar2lunar(year, month, day);
  
  let lunarStr = `${todayLunar.lMonth}/${todayLunar.lDay}`;
  
  if (festival[lunarStr]) {
    return festival[lunarStr];
  } else if (
    todayLunar.lDay !== 1 &&
    todayLunar.lDay !== 15 &&
    todayLunar.lDay !== 2 &&
    todayLunar.lDay !== 16
  ) {
    return '';
  }
  
  return lunarStr;
};

export const getAllFestivalsInMonth = (year, month) => {
  const endDay = new Date(year, month, 0).getDate();
  const festivals = new Set();
  
  for (let i = 1; i <= endDay; i++) {
    const festivalName = getFestivalForDate(year, month, i);
    if (festivalName && festivalName !== '') {
      festivals.add(festivalName);
    }
  }
  
  return Array.from(festivals);
};

export const shouldShowLunarDay = (lunarMonth, lunarDay) => {
  return lunarDay === 1 || lunarDay === 15 || lunarDay === 2 || lunarDay === 16;
};

export const formatLunarDate = (lunarMonth, lunarDay) => {
  const dateStr = `${lunarMonth}/${lunarDay}`;
  return festival[dateStr] || dateStr;
};

const festivalHelper = {
  getFestivalForDate,
  getAllFestivalsInMonth,
  shouldShowLunarDay,
  formatLunarDate
};

export default festivalHelper;
